import { AttendanceStateDto } from '../../api-service/clients';
import { ColorPalette } from '../../components/config';

export function getAttendanceStateColor(selectedAttendanceState?: AttendanceStateDto) {
  switch (selectedAttendanceState) {
    case AttendanceStateDto.OnTime:
      return ColorPalette.SummaryGreen;
    case AttendanceStateDto.NotOnTime:
      return ColorPalette.SummaryOrange;
    case AttendanceStateDto.NotShown:
      return ColorPalette.Crimson;
    case AttendanceStateDto.AbsenceWithReason:
      return ColorPalette.SummaryGreen;
    case AttendanceStateDto.NotRelevant:
      return ColorPalette.CityNightSkies;
    default:
      return 'inherit';
  }
}
